(() => {
  const root = document.querySelector('[data-tcg-hub-recent-singles]');
  if (!root) return;

  const hub = window.Kl24PokemonHub;
  if (!hub) return;

  const grid = root.querySelector('[data-hub-recent-grid]');
  const collectionHandle = root.dataset.collectionHandle || 'pokemon-singles';
  const limit = Math.max(4, Number.parseInt(root.dataset.productsToShow || '6', 10) || 6);
  const minProducts = Math.max(1, Number.parseInt(root.dataset.minProducts || '3', 10) || 3);
  const highlightsAsset = root.dataset.highlightsAsset || '';
  const finishFilter =
    root.dataset.finishFilter ||
    (document.body.classList.contains('template-index') ? 'holo_reverse' : 'all');
  const holoOnly = finishFilter === 'holo_reverse';
  const priceLabel = 'Preis';

  const imageApi = () => window.Kl24ShopifyImage;

  const gridThumbUrl = (url) => {
    const api = imageApi();
    const width = api?.WIDTHS?.gridThumb ?? 360;
    return api?.sizedUrl(url, width) || url;
  };

  const parseTitle = (title) => {
    const raw = String(title || '').trim();
    const match = /(\d+)\s*\/\s*(\d+)/.exec(raw);
    const cardNumber = match ? `${Number.parseInt(match[1], 10)}/${match[2]}` : '';
    let setName = '';
    if (raw.endsWith(')')) {
      const start = raw.lastIndexOf('(');
      if (start >= 0) {
        const inner = raw.slice(start + 1, -1);
        setName = inner.includes(' - ') ? inner.split(' - ').slice(1).join(' - ').trim() : inner.trim();
      }
    }
    const cardName = raw.split('–')[0]?.trim() || raw.split('-')[0]?.trim() || raw;
    return { cardName, setName, cardNumber };
  };

  const normalizeItem = (item) => {
    const parsed = parseTitle(item.title);
    const finish = hub.parseFinishFromSku(item.sku) || '';
    return {
      url: item.url || `/products/${item.handle || ''}`,
      variantId: item.variant_id,
      imageUrl: String(item.image_url || '').trim(),
      cardName: parsed.cardName || item.title || 'Single',
      setName: parsed.setName || item.set_name || '',
      cardNumber: parsed.cardNumber || item.card_number || '',
      priceCents: Number(item.price_cents) || 0,
      available: true,
      sku: item.sku || '',
      finish,
      languageChip: String(item.sku || '').toUpperCase().endsWith('-EN')
        ? { label: 'EN', modifier: 'en' }
        : null,
      handle: item.handle || '',
    };
  };

  const createThumbPlaceholder = (product) => {
    const ph = document.createElement('div');
    ph.className = 'tcg-singles-shop__thumb-placeholder';
    ph.setAttribute('aria-hidden', 'true');
    const num = String(product.cardNumber || '').trim();
    if (num) {
      const numEl = document.createElement('span');
      numEl.className = 'tcg-singles-shop__thumb-placeholder-num';
      numEl.textContent = num;
      ph.append(numEl);
    } else {
      ph.textContent = 'Scan folgt';
    }
    return ph;
  };

  const showThumbPlaceholder = (thumbWrap, product) => {
    thumbWrap.querySelector('.tcg-singles-shop__thumb')?.remove();
    if (!thumbWrap.querySelector('.tcg-singles-shop__thumb-placeholder')) {
      thumbWrap.append(createThumbPlaceholder(product));
    }
  };

  const appendProductThumb = (card, product, index) => {
    const thumbWrap = document.createElement('div');
    thumbWrap.className = 'tcg-singles-shop__thumb-wrap';

    if (product.imageUrl) {
      const thumb = document.createElement('img');
      thumb.className = 'tcg-singles-shop__thumb';
      const api = imageApi();
      const sized = gridThumbUrl(product.imageUrl);
      thumb.src = sized;
      if (api?.srcSet) {
        const set = api.srcSet(product.imageUrl, [
          api.WIDTHS?.gridThumbSm ?? 180,
          api.WIDTHS?.gridThumb ?? 360,
          api.WIDTHS?.gridThumbMd ?? 540,
          api.WIDTHS?.gridThumbLg ?? 720,
        ]);
        if (set) {
          thumb.srcset = set;
          thumb.sizes = '(min-width: 1200px) 270px, (min-width: 750px) 22vw, 42vw';
        }
      }
      thumb.alt = hub.buildImageAlt
        ? hub.buildImageAlt(product)
        : [product.cardName, product.cardNumber].filter(Boolean).join(' ');
      thumb.loading = index < 2 ? 'eager' : 'lazy';
      thumb.decoding = 'async';
      if (index === 0) {
        thumb.fetchPriority = 'high';
      }
      thumb.width = 360;
      thumb.height = 480;
      thumb.addEventListener('error', () => {
        showThumbPlaceholder(thumbWrap, product);
      });
      thumb.addEventListener('load', () => {
        if (thumb.naturalWidth < 12 || thumb.naturalHeight < 12) {
          showThumbPlaceholder(thumbWrap, product);
        }
      });
      thumbWrap.append(thumb);
    } else {
      thumbWrap.append(createThumbPlaceholder(product));
    }

    card.append(thumbWrap);
  };

  const renderCard = (rawItem, index) => {
    const product = normalizeItem(rawItem);
    const card = document.createElement('a');
    card.className = 'tcg-singles-shop__card';
    card.href = product.url;
    card.setAttribute('role', 'listitem');
    card.setAttribute('data-hub-recent-card', '');
    card.setAttribute('data-variant-id', String(product.variantId || ''));

    appendProductThumb(card, product, index);

    const body = document.createElement('div');
    body.className = 'tcg-singles-shop__card-body';

    const name = document.createElement('p');
    name.className = 'tcg-singles-shop__card-name';
    name.textContent = product.cardName;
    body.append(name);

    if (product.setName || product.cardNumber || product.finish) {
      const setLine = document.createElement('p');
      setLine.className = 'tcg-singles-shop__card-set';

      if (product.setName) {
        const setNameEl = document.createElement('span');
        setNameEl.className = 'tcg-singles-shop__set-name';
        setNameEl.textContent = product.setName;
        setLine.append(setNameEl);
      }

      if (product.cardNumber || product.finish) {
        const numberEl = document.createElement('span');
        numberEl.className = 'tcg-singles-shop__set-number';
        numberEl.textContent = product.finish
          ? `${product.cardNumber || ''}${product.cardNumber && product.finish ? ' · ' : ''}${product.finish}`
          : product.cardNumber;
        setLine.append(numberEl);
      }

      body.append(setLine);
    }

    if (product.languageChip) {
      const langEl = document.createElement('span');
      langEl.className = `tcg-singles-shop__lang tcg-singles-shop__lang--${product.languageChip.modifier}`;
      langEl.textContent = product.languageChip.label;
      body.append(langEl);
    }

    if (product.priceCents > 0) {
      const priceWrap = document.createElement('div');
      priceWrap.className = 'tcg-singles-shop__card-price-block';

      const priceLabelEl = document.createElement('span');
      priceLabelEl.className = 'tcg-singles-shop__card-price-label';
      priceLabelEl.textContent = priceLabel;

      const priceValue = document.createElement('p');
      priceValue.className = 'tcg-singles-shop__card-price';
      priceValue.textContent = hub.formatMoney(product.priceCents);

      priceWrap.append(priceLabelEl, priceValue);
      body.append(priceWrap);
    }

    card.append(body);
    return card;
  };

  const filterItems = (items) => {
    if (!holoOnly) return items;
    return items.filter((item) => hub.isHoloOrReverseFinish(item));
  };

  const fetchProductImageUrl = async (handle) => {
    const h = String(handle || '').trim();
    if (!h) return '';
    try {
      const res = await fetch(
        `${window.location.origin}/products/${encodeURIComponent(h)}.json`,
        { credentials: 'same-origin' }
      );
      if (!res.ok) return '';
      const data = await res.json();
      const product = data?.product;
      if (!product) return '';
      const fromImages = (product.images || [])[0]?.src;
      if (fromImages) return String(fromImages).trim();
      return String(product.image?.src || '').trim();
    } catch {
      return '';
    }
  };

  /** Prefer live Shopify product media over possibly stale highlights JSON URLs. */
  const refreshItemImages = async (items) => {
    const handles = items
      .map((item) => String(item.handle || '').trim())
      .filter(Boolean);
    if (!handles.length) return items;

    const byHandle = new Map();
    await Promise.all(
      handles.map(async (handle) => {
        const url = await fetchProductImageUrl(handle);
        if (url) byHandle.set(handle, url);
      })
    );
    if (!byHandle.size) return items;

    return items.map((item) => {
      const fresh = byHandle.get(item.handle);
      return fresh ? { ...item, image_url: fresh } : item;
    });
  };

  const mergeRecentItems = (primary, secondary) => {
    const seen = new Set(primary.map((item) => String(item.variant_id || item.handle || '')));
    const merged = [...primary];
    for (const row of secondary) {
      const key = String(row.variant_id || row.handle || '');
      if (!key || seen.has(key)) continue;
      seen.add(key);
      merged.push(row);
    }
    merged.sort((a, b) => String(b.published_at || '').localeCompare(String(a.published_at || '')));
    return merged;
  };

  const loadItems = async () => {
    const highlights = await hub.fetchHighlights(highlightsAsset);
    const highlightsKey = holoOnly ? 'recent_holo_singles' : 'recent_singles';
    const fromHighlights = filterItems(highlights?.[highlightsKey] || highlights?.recent_singles || []);

    // Live storefront is source of truth for "Frisch eingetroffen".
    let items = filterItems(
      await hub.fetchCollectionProducts(collectionHandle, {
        limit,
        finishFilter,
      })
    );

    if (items.length < limit && fromHighlights.length) {
      items = mergeRecentItems(items, fromHighlights);
    }

    items = await refreshItemImages(items.slice(0, limit));
    return items;
  };

  (async () => {
    const items = await loadItems();
    if (!grid) return;
    if (items.length < minProducts) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    grid.replaceChildren();
    items.forEach((item, index) => grid.append(renderCard(item, index)));
  })();
})();
